import { render, staticRenderFns } from "./PlannerBodies.vue?vue&type=template&id=756d3454&scoped=true&"
import script from "./PlannerBodies.vue?vue&type=script&lang=js&"
export * from "./PlannerBodies.vue?vue&type=script&lang=js&"
import style0 from "./PlannerBodies.vue?vue&type=style&index=0&id=756d3454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756d3454",
  null
  
)

export default component.exports